// extracted by mini-css-extract-plugin
export default {"thumbnail":"ReservationPage_thumbnail__1i1MU","summary_list":"ReservationPage_summary_list__7du5p","cancellation_policy":"ReservationPage_cancellation_policy__i9h0P"};